import { FileText } from 'lucide-react';

import { MarkdownEditor } from '@/components/ui/MarkdownEditor';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'markdown',
  renderInput: ({ field, value, onChange }) => (
    <MarkdownEditor
      value={(value as string) || ''}
      onChange={(md) => onChange(md || null)}
      placeholder={`Wprowadź ${field.name.toLowerCase()} w formacie Markdown…`}
    />
  ),
  renderCell: (_field, value) => {
    if (!value) return '—';
    const plain = String(value)
      .replace(/[#*`_[\]()]/g, '')
      .trim()
      .slice(0, 80);
    return (
      <div className="flex items-center gap-2">
        <FileText className="h-3.5 w-3.5 flex-shrink-0 text-text-muted" />
        <span className="text-sm text-text-primary">
          {plain}
          {plain.length >= 80 ? '…' : ''}
        </span>
      </div>
    );
  },
  validate: (value, field) => {
    if (!value) return field.isRequired ? 'Pole wymagane' : null;
    const rules = (field.validationRules ?? {}) as Record<string, unknown>;
    const text = String(value);
    if (rules['minLength'] && text.length < Number(rules['minLength']))
      return `Minimum ${rules['minLength']} znaków`;
    if (rules['maxLength'] && text.length > Number(rules['maxLength']))
      return `Maksimum ${rules['maxLength']} znaków`;
    return null;
  },
  defaultValue: '',
});
